import { SET_LANGUAGE, ADD_LANGUAGE_VALUES} from '../actions/DataPageAction'

const data = {
    variables: {config: {}, content: {}},
    view: {},
}


// eslint-disable-next-line import/no-anonymous-default-export
export default (state = data, action) => {
  // console.log('CAMBIAR LENGUGE', action, state)
    switch (action.type) {
      case ADD_LANGUAGE_VALUES: 
        return { variables: {...state.variables, ...action.payload} };
      case SET_LANGUAGE: 
        let variables = {config: {}, content: {}}
        if (action.payload !== null) {
          if (action.payload.config !== undefined) {
            variables.config = action.payload.config
          }
          if (action.payload.content !== undefined) {
            variables.content = action.payload.content
          }
        }
        return {variables};
        // return {variables: state.variables.concat(action.payload)};
        // return {variables: state.concat(action.payload)};
      // case 'GET_LANGUAGE': 
      //   console.log('elvalue', action.payload)
      //   let t = state.variables[action.payload]
      //   console.log('hhhhhhhhh', t)
      //   if (t) {
      //       return t
      //   }
      //   return `{lang.${action.payload}}`
        // return {variables: state.variables.concat(action.payload)};
      
      default: 
        return state;
      
    }
  }

  